import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';
import RouterConfig from './RouterConfig';

const App: React.FC = () => {
  return (
    <Box sx={{width: '100%', 
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      overflow: 'hidden',}}>
      <CssBaseline />
        <RouterConfig />
        </Box>
  );
};

export default App;
